import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { UserRole } from '@promtver/contracts';
import { StateBlock } from '@promtver/ui-kit';

import { ru } from '../i18n/ru';
import { useAuth } from './AuthProvider';

/**
 * Доступ к панели — для ролей «Администратор региона» и «Оператор платформы»
 * (ТЗ §3.1, Приложение В). Проверка прав на объектах — на сервере.
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { user, isRestored, logout } = useAuth();
  const location = useLocation();

  if (!isRestored) {
    return null;
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  if (user.role !== UserRole.RegionAdmin && user.role !== UserRole.PlatformOperator) {
    return (
      <div className="mx-auto max-w-panel p-4">
        <StateBlock
          kind="forbidden"
          title={ru.login.errorForbidden}
          actionLabel={ru.nav.logout}
          onAction={logout}
        />
      </div>
    );
  }

  return <>{children}</>;
}
